module.exports = __webpack_public_path__ + "./images/p18.JPG?8b1dec4f6cd07f2ab1e2bf947bd63dd9";


//////////////////
// WEBPACK FOOTER
// ./src/products/p18.JPG
// module id = 53
// module chunks = 0